import { render, staticRenderFns } from "./organization-widget.vue?vue&type=template&id=37216671&scoped=true&"
import script from "./organization-widget.vue?vue&type=script&lang=js&"
export * from "./organization-widget.vue?vue&type=script&lang=js&"
import style0 from "./organization-widget.vue?vue&type=style&index=0&id=37216671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37216671",
  null
  
)

export default component.exports